import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// 性能监控初始化
import { initPerformanceMonitoring } from './lib/performance'
// PWA 初始化
import { initPWA } from './lib/pwa'
// 预加载器初始化
import { initializePreloader } from './lib/preloader'

// SPA路由强化处理
function ensureHashRouter() {
  console.log('🎯 React应用启动路由检查:', window.location.href);
  
  // 确保根路径有正确的hash
  if (window.location.pathname === '/' && !window.location.hash) {
    console.log('📍 React启动时添加根hash');
    window.history.replaceState(null, '', '/#/');
  }
  
  // 如果URL有非根路径但没有hash，转换为hash路由
  if (window.location.pathname !== '/' && !window.location.hash.startsWith('#/')) {
    const newHash = '#' + window.location.pathname + window.location.search;
    console.log('🔄 React启动时转换为hash路由:', newHash);
    window.history.replaceState(null, '', '/' + newHash);
  }
}

// 初始化性能监控
if (typeof window !== 'undefined') {
  // 路由处理必须在React渲染前执行
  ensureHashRouter();
  
  initPerformanceMonitoring();
  
  // 初始化预加载器
  initializePreloader();
  
  // 初始化 PWA
  initPWA().catch(error => {
    console.error('PWA 初始化失败:', error);
  });
}

const rootElement = document.getElementById("root");
if (rootElement) {
  console.log('✅ React应用正在启动...');
  createRoot(rootElement).render(<App />);
} else {
  console.error('❌ 无法找到root元素');
}
